import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { AppDataGrid } from '@/components/ui';
import { UserDto } from '@cloudcost/shared-types/users';

interface AssignedTechUsersProps {
  cloudAccountId: number;
  assignedTechUsers: UserDto[];
  onAddUser: () => void;
  onDeleteUser: (user: UserDto) => void;
}

export const AssignedTechUsers: React.FC<AssignedTechUsersProps> = ({
  assignedTechUsers,
  onAddUser,
  onDeleteUser,
}) => {
  const columns = [
    { field: 'username', headerName: 'User name', flex: 1 },
    { field: 'firstName', headerName: 'First name', flex: 1 },
    { field: 'lastName', headerName: 'Last name', flex: 1 },
    { field: 'email', headerName: 'E-mail', flex: 1 },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 80,
      renderCell: (params: any) => (
        <Button
          variant="outlined"
          color="error"
          size="small"
          onClick={() => onDeleteUser(params.row as UserDto)}>
          Delete
        </Button>
      ),
    },
  ];

  return (
    <Box>
      <Typography variant="h6" component="h3" sx={{ mb: 2 }}>
        Assigned Tech Users
      </Typography>

      <Box sx={{ height: 504, mb: 2 }}>
        <AppDataGrid
          rows={assignedTechUsers}
          columns={columns}
          getRowId={(row) => row.id}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 5, page: 0 },
            },
          }}
        />
      </Box>

      <Box sx={{ display: 'flex', gap: 2 }}>
        <Button
          variant="contained"
          onClick={onAddUser}
          color="primary"
          size="small">
          Add User
        </Button>
      </Box>
    </Box>
  );
};
